import * as yup from 'yup';

import { stringSchema } from '../../helpers';

export const legalEntitiesFormSchema = yup
  .object({
    legalEntities: yup.array().of(
      yup.object({
        legalEntityName: stringSchema(),
      })
    ),
  })
  .required();
